var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'דיווחת לנו על תקלה...',"text":'הצוות שלנו עובד לתקן אותה מהר! נשלח לך לינק לתזרים מעודכן ברגע שהיא תיפתר.',"icon-type":'danger'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }